import React from "react";

import { Icon } from "@sportal/cdk/icon/Icon";
import { Tooltip } from "../tooltip/Tooltip";
import { NotMobile, Mobile } from "../../hocs/Responsive";
import { useIntlTranslate } from "../../hooks";

export const RoamingLimitNearingWarning = () => {
  const translate = useIntlTranslate();
  const ariaText = translate("roaming_reaching_limit_info");
  const labelText = translate("roaming_reaching_limit");

  return (
    <div className={"roaming-nearing-limit-warning"}>
      <Mobile>
        <Tooltip
          theme={"dark"}
          aria-label={labelText}
          content={ariaText}
          role="tooltip"
        >
          <span className="sr-only">{ariaText}</span>
          <Icon icon={"fa-regular fa-exclamation-triangle"} />
        </Tooltip>
      </Mobile>
      <NotMobile>
        <Icon icon={"fa-regular fa-exclamation-triangle"} />
        <Tooltip
          theme={"dark"}
          aria-label={labelText}
          content={ariaText}
          role="tooltip"
        >
          <span className="sr-only">{ariaText}</span>
          <span aria-hidden={true}>{labelText}</span>
        </Tooltip>
      </NotMobile>
    </div>
  );
};
